<template>
    <div class="spo-card rounded bordered p-3 mb-4">

        <v-chip v-if="groupe?.disable == '1'" variant="elevated" elevation="0" color="red" density="compact"
            class="mb-1">
            Lien désactivé
        </v-chip>
        <v-chip v-else variant="elevated" elevation="0" color="green" density="compact" class="mb-1">
            Lien actif
        </v-chip>
        <v-row>
            <v-col cols="12" md="6">
                <div><strong>Nom du groupe:</strong> {{ groupe?.nom }}</div>
                <div v-if="groupe?.nom_responsable">
                    <strong>Responsable :</strong> {{ groupe.nom_responsable }} {{ groupe.mail_responsable ? '(' +
                        groupe.mail_responsable + ')' : '' }}
                </div>
                <div><strong>Date d'expiration : </strong> {{ expirationLabel }}</div>
                <div v-if="groupe?.informations_supplementaires" class="mt-2">
                    <strong>Informations supplémentaires :</strong>
                    <div class="text-body-2 spo-pre-line">{{ groupe.informations_supplementaires }}</div>
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <div class="d-flex align-center flex-wrap ga-2 mb-1">
                    <div v-if="groupe?.max_inscrits && groupe.max_inscrits != '0'">
                        <strong>Limite :</strong> {{ groupe.max_inscrits }} inscription(s)
                    </div>
                    <div v-else-if="isAdminSuivi">
                        <strong>Limite :</strong> aucune (0 = pas de limite)
                    </div>
                    <SportipsButton v-if="isAdminSuivi" @onClick="openDialogMaxInscrits" icon="mdi-pencil"
                        variant="text" size="small" color="primary">
                        Modifier la limite
                    </SportipsButton>
                </div>
                <div>
                    <strong>Utilisation :</strong>
                    {{ groupe?.nb_inscrits || 0 }} inscription(s)
                    ({{ groupe?.nb_commandes || 0 }} commande(s))
                </div>

                <v-dialog v-model="dialogMaxInscrits" width="500" max-width="100%" scroll-strategy="none">
                    <v-card>
                        <v-card-title>Modifier la limite d'inscriptions</v-card-title>
                        <v-card-text>
                            <div class="text-body-2 text-medium-emphasis mb-3">
                                Indiquez le nombre maximum d'inscriptions pour ce lien. La valeur 0 supprime la limite.
                                Elle ne peut pas être inférieure au nombre d'inscrits actuels ({{ nbInscritsActuels }}).
                            </div>
                            <v-text-field v-model="maxInscritsDraft" type="number" min="0" step="1" label="Limite"
                                hide-details="auto" :error-messages="maxInscritsError"></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="grey" variant="text" @click="dialogMaxInscrits = false"
                                :disabled="savingMaxInscrits">Annuler</v-btn>
                            <v-btn color="primary" :loading="savingMaxInscrits" @click="confirmMaxInscrits">
                                Confirmer
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>

        <v-divider class="my-3"></v-divider>

        <div class="d-flex flex-column ga-1">
            <div class="d-flex align-center ga-2">
                <span class="font-weight-bold text-body-2">Lien d'inscription : </span>
                <div class="text-body-2 text-break">{{ lienInscriptionUrl }}</div>
            </div>
            <div class="d-flex align-center ga-2">
                <span class="font-weight-bold text-body-2">Lien de suivi du groupe : </span>
                <div class="text-body-2 text-break">{{ lienSuiviUrl }}</div>
            </div>
            <div class="font-weight-bold text-body-2 mb-1"><u>Paramètres</u></div>
            <div class="d-flex align-center ga-2">
                <span class="font-weight-bold text-body-2">Parcours payants à l'inscription : </span>
                <div class="text-body-2 text-break">{{ groupe?.doit_payer == '1' ? 'Oui' : 'Non' }}</div>
            </div>
            <div class="d-flex align-center ga-2">
                <span class="font-weight-bold text-body-2">Peut s'inscrire course pleine : </span>
                <div class="text-body-2 text-break">{{ groupe?.inscription_course_complete == '1' ? 'Oui' : 'Non' }}
                </div>
            </div>
            <div class="d-flex align-center ga-2">
                <span class="font-weight-bold text-body-2">Limiter les parcours disponibles : </span>
                <div class="text-body-2 text-break"><span
                        v-if="groupe?.limit_acces_parcours == '1' && groupe?.filter_parcours && String(groupe.filter_parcours).length > 0">
                        Limité à : <strong>{{ filterParcoursLabel }}</strong>
                    </span>
                    <span v-else>Tous les parcours</span>
                </div>
            </div>
            <div class="d-flex align-center ga-2">
                <span class="font-weight-bold text-body-2">Options payantes à l'inscription : </span>
                <div class="text-body-2 text-break">{{ groupe?.doit_payer_options == '1' ? 'Oui' : 'Non' }}
                </div>
            </div>
            <div class="d-flex align-center ga-2">
                <span class="font-weight-bold text-body-2">Peut s'inscrire options complètes : </span>
                <div class="text-body-2 text-break">{{ groupe?.inscriptions_options_completes == '1' ? 'Oui' : 'Non' }}
                </div>
            </div>
            <div class="d-flex align-center ga-2"> <span class="font-weight-bold text-body-2">Type de paiement : </span>
                <div class="text-body-2 text-break">{{ typePaiementLabel }}</div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";

export default {
    props: {
        groupe: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            dialogMaxInscrits: false,
            maxInscritsDraft: '',
            maxInscritsError: '',
            savingMaxInscrits: false,
        };
    },
    computed: {
        ...mapStores(useMainStore),
        isAdminSuivi() {
            return this.mainStore.authAdmin?.isLogged && this.mainStore.authAdmin?.hasModuleAccess;
        },
        nbInscritsActuels() {
            return parseInt(this.groupe?.nb_inscrits, 10) || 0;
        },
        expirationLabel() {
            if (!this.groupe?.date_expiration || this.groupe.date_expiration === '0000-00-00') return 'Aucune';
            return this.$moment(this.groupe.date_expiration).format('DD/MM/YYYY');
        },
        lienInscriptionUrl() {
            if (!this.groupe?.token || !this.mainStore.module?.base) return '';
            const domain = window.location.hostname;
            return `https://${domain}/inscription/${this.mainStore.module.base}?groupe=${this.groupe.token}`;
        },
        lienSuiviUrl() {
            if (!this.groupe?.token || !this.mainStore.module?.base) return '';
            const domain = window.location.hostname;
            return `https://${domain}/inscription/${this.mainStore.module.base}/suivi-lien-groupe/${this.groupe.token}`;
        },
        typePaiementLabel() {
            const map = { en_ligne: 'En ligne', virement: 'Virement', cheque: 'Chèque' };
            return map[this.groupe?.type_paiement] || 'En ligne';
        },
        filterParcoursLabel() {
            if (!this.groupe?.filter_parcours) return '';
            const ids = String(this.groupe.filter_parcours).split(',').map(id => id.trim()).filter(id => id);
            const list = this.mainStore.module?.courses?.list || [];
            return ids.map(id => {
                const course = list.find(c => String(c.id) === id);
                return course ? course.nom : id;
            }).join(', ');
        },
    },
    methods: {
        openDialogMaxInscrits() {
            this.maxInscritsError = '';
            const cur = this.groupe?.max_inscrits;
            this.maxInscritsDraft = cur !== undefined && cur !== null && String(cur) !== '' ? String(cur) : '0';
            this.dialogMaxInscrits = true;
        },
        validateMaxInscritsDraft() {
            this.maxInscritsError = '';
            const n = parseInt(String(this.maxInscritsDraft).trim(), 10);
            if (Number.isNaN(n) || n < 0) {
                this.maxInscritsError = 'Veuillez saisir un entier positif ou zéro.';
                return null;
            }
            if (n > 0 && n < this.nbInscritsActuels) {
                this.maxInscritsError = `La limite doit être au moins égale au nombre d'inscrits actuels (${this.nbInscritsActuels}).`;
                return null;
            }
            return n;
        },
        async confirmMaxInscrits() {
            const value = this.validateMaxInscritsDraft();
            if (value === null) return;
            if (!this.groupe?.id) {
                this.mainStore.notification.send("Identifiant du groupe manquant.", "error");
                return;
            }
            this.savingMaxInscrits = true;
            try {
                const res = await AdminService.updateLienGroupeMaxInscrits(this.groupe.id, value);
                if (res === false) {
                    this.mainStore.notification.send("Impossible de mettre à jour la limite.", "error");
                    return;
                }
                if (res?.error) {
                    this.mainStore.notification.send(typeof res.error === 'string' ? res.error : "La mise à jour a été refusée.", "error");
                    return;
                }
                this.mainStore.notification.send("Limite d'inscriptions mise à jour.", "success");
                this.dialogMaxInscrits = false;
                this.$emit('limite-updated');
            } finally {
                this.savingMaxInscrits = false;
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.spo-pre-line {
    white-space: pre-line;
}
</style>
